import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import EditArbitrator from './EditArbitrator';
import AddArbitrator from './AddArbitrator';
import useFetch from '../../Utilities/useFetch';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FuncFetch from '../../Utilities/funcFetch';
import { Form, Spinner } from 'react-bootstrap';

const AllArbitrators = () => {
    const [rowData, setRowData] = useState([]);
    const [selectedArbitrator, setSelectedArbitrator] = useState(null);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [isAddFormOpen, setIsAddFormOpen] = useState(false);
    const { data: arbitrators, loading: arbitratorsLoading, refetch } = useFetch(true, `${process.env.REACT_APP_API_URL}/Admin/GetArbitrators`, 'GET');

    useEffect(() => {
        if (arbitrators) {
            setRowData(arbitrators);
        }
    }, [arbitrators]);

    const openEditForm = (arbitrator) => {
        setSelectedArbitrator(arbitrator);
        setIsEditFormOpen(true);
    };

    const closeEditForm = () => {
        setSelectedArbitrator(null);
        setIsEditFormOpen(false);
        refetch();
    };

    const openAddForm = () => {
        setIsAddFormOpen(true);
    };

    const closeAddForm = () => {
        setIsAddFormOpen(false);
        refetch();
    };

    const handleDisableArbitrator = async (email) => {
        try {
            await FuncFetch(`${process.env.REACT_APP_API_URL}/Admin/DisableArbitrator`, { email }, 'POST');
            setRowData((prevData) =>
                prevData.map((arbitrator) =>
                    arbitrator.arbitratorEmail === email ? { ...arbitrator, active: false } : arbitrator
                )
            );
        } catch (error) {
            console.error('Error disabling arbitrator:', error);
        }
    };

    const onRowClicked = (event) => {
        openEditForm(event.data);
    };

    const columnDefs = [
        { 
            headerName: 'Name', 
            field: 'arbitratorName', 
            sortable: true, 
            filter: true 
        },
        { 
            headerName: 'Email', 
            field: 'arbitratorEmail', 
            sortable: true, 
            filter: true 
        },
        {
            headerName: 'Active',
            field: 'active',
            sortable: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                values: [true, false],
                valueFormatter: (params) => params.value ? 'Active' : 'Inactive'
            },
            cellRenderer: (params) => {
                return (
                    <Form.Check 
                        checked={params.data.active} 
                        disabled={!params.data.active} 
                        type="switch" 
                        id={`active-switch-${params.data.arbitratorEmail}`}
                        label="Active" 
                        onChange={() => handleDisableArbitrator(params.data.arbitratorEmail)} 
                    />
                )
            },
        },
    ];

    return (
        <div>
            <Row style={{ marginTop: '10px'}}>
                <Col>
                    <h2>Arbitrators</h2>
                </Col>
                <Col>
                    {arbitratorsLoading && <Spinner animation="border"/>}
                </Col>
                <Col style={{display:'flex', justifyContent:'flex-end'}}>
                    <Button onClick={openAddForm}>
                        Add Arbitrator
                    </Button>
                </Col>
            </Row>
            <div className="ag-theme-quartz grid">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onRowClicked={onRowClicked}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                    defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: true
                    }}
                />
            </div>
            
            {/* Edit Arbitrator Modal */}
            {isEditFormOpen && (
                <EditArbitrator
                    arbitrator={selectedArbitrator}
                    onClose={closeEditForm}
                    onSuccess={refetch}
                />
            )}
            
            {/* Add Arbitrator Modal */}
            {isAddFormOpen && (
                <AddArbitrator
                    show={isAddFormOpen}
                    onClose={closeAddForm}
                    onSuccess={refetch}
                />
            )}
        </div>
    );
};

export default AllArbitrators;